import React from 'react';
import './videoModal.css';
import useReRouteHook from '../../../assets/hooks/useReRouteHook';
import { toAbsoluteUrl } from '../../../assets/helpers/AssetHelpers';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';

interface VideoModalProps {
	videoSrc: string | null;
	isOpen: boolean;
	onClose: () => void;
	title: string;
	category: string;
	categoryUrl?: string;
}

const VideoModal: React.FC<VideoModalProps> = ({
	videoSrc,
	isOpen,
	onClose,
	title,
	category,
	categoryUrl,
}) => {
	const { reRouteButtonRenderer } = useReRouteHook();
	if (!isOpen) return null;

	const shareUrl = window.location.href;
	const encodedShareUrl = encodeURIComponent(shareUrl);
	const emailSubject = encodeURIComponent(`Check this out: ${title}`);
	const emailBody = encodedShareUrl;

	return (
		<div
			className="modal fade show modal-dialog-centered video-modal-dialog-centered"
			tabIndex={-1}
			style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
			role="dialog">
			<div className="modal-dialog modal-lg" role="document">
				<div className="modal-content">
					<div className="modal-header border-bottom-0 pb-0 d-flex justify-content-between align-items-cemter">
						<div>
							<div className="ur_bold fs-20 color30">{category}</div>
						</div>
						<div className="d-flex gap-2 align-items-center">
							<a
								href={`https://wa.me/?text=${encodedShareUrl}`}
								target="_blank"
								rel="noopener noreferrer"
								className="btn btn-sm btn-light bg-transparent border-0">
								<img src={toAbsoluteUrl('video-section/Whatsapp.svg')} alt="WhatsApp" width={24} />
							</a>

							<a
								href={`mailto:?subject=${emailSubject}&body=${emailBody}`}
								className="btn btn-sm btn-light bg-transparent border-0">
								<img src={toAbsoluteUrl('video-section/gmail.svg')} alt="Gmail" width={24} />
							</a>

							<button
								type="button"
								className="btn bg-transparent ps-1 border-0"
								onClick={() => {
									navigator.clipboard.writeText(shareUrl);
									toast.success('Link copied to clipboard');
								}}>
								<img src={toAbsoluteUrl('video-section/share.svg')} alt="Copy" width={24} />
							</button>
							{/* Close */}
							<button
								type="button"
								className="btn-close video-modal-btn-close"
								onClick={onClose}
								aria-label="Close"></button>
						</div>
					</div>
					<div className="modal-body">
						<div className="video-container-responsive">
							<iframe
								src={`${videoSrc || ''}?&rel=0&modestbranding=1&autoplay=1`}
								title="YouTube video player"
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								referrerPolicy="strict-origin-when-cross-origin"
								allowFullScreen
								className="rounded-3 video-section-modal"></iframe>
						</div>
						<div className="d-flex justify-content-between">
							<Link
								to={categoryUrl || '#'}
								className="in_reg fs-18 color30"
								onClick={(e) => {
									window.scrollTo(0, 0);
									if (
										!categoryUrl ||
										categoryUrl.includes('undefined') ||
										categoryUrl.includes('null')
									) {
										e.preventDefault();
									}
									onClose();
								}}>
								{title}
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default VideoModal;
